// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__d6T3o","input":"SearchBar_input__X4gN_","btn":"SearchBar_btn__1mTGn"};